import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import Button from "../../../../../components/ui/Button";
import { CloseIcon } from "../../../../../assets/Icons";

interface Props {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}

export const TermsAndCondition: React.FC<Props> = ({ open, onYes, onNo }) => {
  return (
    <div>
      <Dialog
        open={open}
        keepMounted
        onClose={onNo}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
          }}
        >
          <DialogTitle id="alert-dialog-slide-title" style={{ margin: 0, padding: 0 }}>
            Terms and Conditions
          </DialogTitle>

          <CloseIcon
            onClick={onNo}
            style={{
              cursor: "pointer",
              color: "#444",
            }}
          />
        </div>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            This document is an electronic record in terms of Information Technology Act, 2000 and
            rules there under as applicable and the amended provisions pertaining to electronic
            records in various statutes as amended by the Information Technology Act, 2000. This
            electronic record is generated by a computer system and does not require any physical or
            digital signatures.
            <br />
            <br />
            This document is published in accordance with the provisions of Rule 3(1) of the
            Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing
            the rules and regulations, privacy policy and Terms and Conditions for access or usage
            of the Website.
            <br />
            <br />
            The domain name www.moneyhop.co (hereinafter referred to as "Website") is owned by
            Unobanc Private Limited, a company incorporated under the Companies Act, 2013 with its
            registered office at office at 81/1, Gopal Bhawan Lane No 11 Turner Road, Clement Town,
            Dehradun, Uttarakhand 248001 India (hereinafter referred to as Company or Hop).
            <br />
            <br />
            The use of the Website, services including Remittance Facility (defined hereinafter) and
            tools are governed by the following terms and conditions (these terms and conditions
            shall be referred to as "Terms and Conditions" hereinafter) as applicable to the Website
            including the applicable policies which are incorporated herein by way of reference. If
            You transact on the Website, You shall be subject to the policies that are applicable to
            the Website for such transaction. By mere use of the Website, You shall be contracting
            with the Company and these terms and conditions including the policies constitute Your
            binding obligations, with the Company. For the purpose of these Terms of Use, wherever
            the context so requires "You" or "User" shall mean any natural or legal person who has
            agreed to become a purchaser, seller or remitter on the Website by providing information
            and data on the Website as required for using the computer systems. The Company allows
            the User to browse the Website but does not allow the user to make purchases, sale and
            remittance without providing the information as required from a natural or legal person
            for transactions qua 'Foreign Exchange products' on the Website or otherwise.
            <br />
            <br />
            When You use any of the services provided by us through the Website, You will be subject
            to the rules, guidelines, policies, terms, and conditions applicable to such service,
            and they shall be deemed to be incorporated into these Terms and Conditions and shall be
            considered as part and parcel of these Terms and Conditions. We reserve the right, at
            our sole discretion, to change, modify, add or remove portions of these Terms and
            Conditions, at any time without any prior written notice to You. It is Your
            responsibility to review these Terms and Conditions periodically for updates / changes.
            Your continued use of the Website following the posting of changes will mean that You
            accept and agree to the revisions or updates as the case may be. As long as You comply
            with these Terms and Conditons, We grant You a personal, non-exclusive,
            non-transferable, limited privilege to enter and use the Website.
            <br />
            <br />
            Use of the Website is available only to persons who can form legally binding contracts
            under The Indian Contract Act, 1872. Persons who are "incompetent to contract" within
            the meaning of the Indian Contract Act, 1872 including but not limited to minors,
            un-discharged insolvents etc. are not eligible to use the Website. If You are a minor
            i.e. under the age of 18 years, You shall not be eligible to be a User of the Website
            and shall not transact on or use the Website. As a minor if You wish to use or transact
            on the Website, such use or transaction may be made by Your legal guardian or parents on
            the Website. The Company reserves the right to refuse to provide You with access to the
            Website if it is brought to our notice or if it is discovered that You are under the age
            of 18 years.
            <br />
            <br />
            Overview of Remittance Facility
            <br />
            The Remittance Facility (as defined below) is made available by the bank on the Website
            and further described below and elsewhere on the Website, among other things, provide a
            Registered User with a technology platform to place requests for Remittance Facility and
            also track the status through the Website. In order to avail of the facilities described
            above the Registered User should make the transfer of funds from the Registered User’s
            own resident individual account maintained with his/her bank in India. Remittance
            Facility requests can only be made by the Registered User for the purposes permitted by
            the bank.
            <br />
            <h4> Fees and Charges</h4>
            The bank can set its own fees and charges for facilities (including the Remittance
            Facility) and may revise the same at any time and the availability of facilities
            displayed or offered on or through the Website are subject to change. The bank shall
            give prior notice of 30 days for implementing such changes in fees and charges. Nothing
            contained on the Website constitutes an offer, promise or commitment to grant or provide
            any facility. While the bank endeavours to post accurate and updated information on the
            Website, the Registered User must verify the same before taking any action or entering
            into any transaction.
            <br />
            Hop does not control and is not responsible in any manner for any fees or charges, if
            any, that may be imposed by any banks involved in the international wire transfer,
            including but not limited to correspondent or Beneficiary Bank such financial
            institution(s) or any other third parties in connection with the wire transfer.
            <br />
            Registered Users acknowledge and understand that when the funds are remitted by a
            Registered User, hop would be required to effect the conversion at the applicable
            exchange rate prevailing on the day of conversion, subject to availability of exchange
            rate. The Registered User agrees that the prevailing exchange rate is the exchange rate
            applicable at the time of conversion of funds which will be applicable for processing
            the user's transaction request.
            <br />
            Neither the Registered User nor the Beneficiary/ recipient will be entitled to any
            interest for the period during which the funds to be remitted are with the bank, are in
            the course of remittance, or for any other period.
            <br />
            <h4> Eligible Users</h4>
            In order to access and use the product and avail of the Remittance Facility, the
            Registered User must be an individual of at least 18 years of age having the capacity to
            enter into legally binding contracts under the law applicable to the Registered User.
            The Registered User must be a resident individual holding a bank account with any bank
            in India, must hold a Pan card and Aadhaar card. Further the customer/s whose account
            has been classified as delinquent before shall not be eligible to avail the Remittance
            Facility. Residents of India (collectively, "Residents") shall access, use and avail of
            the Website and the remittance facilities only to the extent the domestic laws of India
            and such countries permit them to access, use and avail of the Website and the
            facilities. All non-residents understand that by accessing, using and availing of the
            Website and the facilities, they may be violating local laws in India and/or such other
            countries. The Registered User agrees that it will be solely and absolutely liable for
            any liability incurred in this regard and the Registered User will indemnify the bank
            against any liability incurred by the bank in this regard.
            <br />
            <h4> Registration Information</h4>
            Only limited access to the Website is available to non-Registered Users. Non-Registered
            Users are not permitted to avail the Remittance Facility. In order to obtain increased
            access to the Website and in order to avail of the Remittance Facility, every Person who
            is desirous of availing such facilities is required to register on the Website as a
            Registered User. Subject to the other Facility T&C, upon registration as a Registered
            User, the Website will register the relevant Registered User ID and Registered User
            Password. The Registered User hereby agrees that he shall not get registered more than
            once in the Website for availing the Remittance Facility.
            <br />
            The Registered User agrees to provide true, accurate, current and complete information,
            as prompted by the registration form (for self or Beneficiary) on the Website, and to
            update this information to keep it true, accurate, current and complete at all times.
            If, in the judgment of or to the knowledge of the bank, any information provided by the
            Registered User is untrue, inaccurate, not current or incomplete, the bank retains the
            right to terminate the Registered User's registration and refuse the Registered User
            access to or use of the Website or any facilities, including the cancellation of pending
            transactions. The bank reserves the right to request the Registered User, at any time
            and from time to time, for additional information and/or proof of authenticity of any
            information; the Registered Users continued access to the Website and the facilities,
            including the completion of any ongoing transaction, may be subject to the receipt by
            the bank of such additional information or proof thereof.
            <br />
            The Registered User will be solely and absolutely responsible for maintaining the
            secrecy and confidentiality of all Registered User IDs and Registered User Passwords and
            be fully responsible and liable for all transactions and activities that occur under the
            Registered Users ID and using the Registered Users Password, including any unauthorised
            use or misuse of such Registered User ID and/or Registered User Password and the bank
            shall have no obligation to verify the authenticity of any such transaction or activity.
            In consideration of the bank agreeing to provide the Remittance Facility as per the
            Facility T&C, the Registered User hereby unconditionally agrees to indemnify the bank
            and hold the bank harmless against any liability, costs, damages, claims, suits, and
            proceedings based upon or relating to such unauthorized access and use. Without
            prejudice to the aforesaid, the Registered User agrees to log out from his or her
            Registered User Account at the end of each session and to immediately notify the bank
            via E-mail on the Website, or through the Call Centre, or registered post ad of any
            suspected loss, theft, unauthorised usage of the Registered User ID or Registered Users
            Password, any other breach of security, or any receipt by the Registered User of
            confirmation of a transaction, funds or other activity which the Registered User did not
            authorise; or any inaccurate information in the Registered Users account balances or
            transaction history.
            <br />
            If the Registered User forgets his/her Registered User Password, the bank may, subject
            to verification and the banks satisfaction as to the Registered Users identity, allow
            the Registered User to reset his/her password or enable user ID as per the process
            detailed on the Website.
            <br />
            The bank reserves the right to reject registration of remitter as a Registered User if
            the bank is not satisfied with results of the Know Your Customer (“KYC”) and anti-money
            laundering diligence checks conducted by the bank.
            <br />
            The bank retains the right to terminate the registration of any Registered User and
            refuse the Registered User access to or use of the Website or any facilities, including
            the cancellation of pending transactions, as per its discretion.
            <br />
            <h4> Acceptable Use</h4>
            <br />
            A Registered User/Visitor shall not:
            <br />
            Use or access the Website or any facility to do, facilitate or support any act that
            violates the Facility T&C or any rules and regulations of any jurisdiction, including
            but not limited to rules and regulations relating to money laundering, illegal gambling
            activities, fraud, or funding of terrorist organizations.
            <br />
            Restrict or inhibit any other Person from accessing, using and enjoying the Website or
            the facilities.
            <br />
            Modify, copy, distribute, transmit, display, perform, publish, licence, create
            derivative works from, transfer or sell any information, designs, logos, trademarks,
            software, facilities, products or services obtained on or through the Website, except as
            permitted by the copyright owner or other right holder thereof.
            <br />
            Post or transmit any unlawful, fraudulent, libellous, defamatory, obscene, pornographic,
            profane, threatening, abusive, hateful, offensive, or otherwise objectionable
            information or statement of any kind including, without limitation, any information or
            statement constituting or encouraging conduct that would constitute a criminal offence,
            give rise to civil liability, or otherwise violate any local, state, national, foreign
            or other law.
            <br />
            Post or transmit any advertisements, solicitations, chain letters, pyramid schemes,
            investment opportunities or schemes or other unsolicited commercial communication
            (except as otherwise expressly permitted by the bank in writing) or engage in spamming
            or flooding.
            <br />
            Post or transmit any information or software which contains a virus, trojan horse, worm
            or other harmful component.
            <br />
            Post, publish, transmit, reproduce, distribute or in any way exploit any information,
            software or other material obtained from or through the Website for commercial purposes.
            <br />
            Upload, post, publish, transmit, reproduce or distribute in any way, information,
            software or other material obtained on or through the Website which is protected by
            copyright or other proprietary right, or derivative works with respect thereto, except
            as permitted by the copyright owner or other right holder thereof.
            <br />
            Upload, post, publish, reproduce, transmit or distribute in any way any component of the
            Website itself or derivative works with respect thereto, except as permitted by the bank
            or the copyright owner or other right holder thereof, the Website being copyrighted
            under the relevant laws.
            <br />
            Attempt to decompile or reverse engineer any of the software available on the Website.
            <br />
            Make any attempt to hack into the Website or otherwise attempt to subvert any firewall
            or other security measure of the Website and if the Registered User/ Visitor becomes
            aware of any shortcoming in the security on the Website the Visitor shall forthwith
            inform the bank of the same in writing.
            <br />
            Reproduce, duplicate, copy, sell, resell or exploit for any commercial purposes, any
            portion of the Website, use of the facilities, or access to the Website or the
            facilities, other than as provided within the scope of the service.
            <br />
            Disclose to any other Person, in any manner whatsoever, any information of a
            confidential nature relating to the bank or the affiliate partners obtained in the
            course of using or accessing the Website or availing of any facility.
            <br />
            <h4> Limitations of Offering</h4>
            The bank shall not be under any duty to assess the prudence or otherwise of any
            instruction or transaction given or entered by the Registered User. Nothing provided on
            the Website should be construed as advice of any nature and the Registered Users are
            advised to consult professionals in this regard prior to taking any decision.
            <br />
            The Registered User hereby authorizes the bank to verify any information provided.
            <br />
            The bank shall not be responsible for any error or omission made by the Registered User
            in keying in or otherwise providing the information required to avail of the Remittance
            Facility or any consequences as a result of such error or omission. If you provide an
            incorrect account number for the Beneficiary/ recipient or an incorrect identification
            number for the Beneficiary/recipients financial institution, you may lose the entire
            amount of the funds transferred and the bank will not be liable for the same in any
            manner whatsoever.
            <br />
            The bank shall endeavour to carry out the requests received under the Remittance
            Facility. However, the bank shall be entitled, in its sole and absolute discretion, to
            refuse to comply with all or any of a Registered Users instructions or requests without
            assigning any reason.
            <br />
            The Registered User cannot amend, cancel or revoke any request made to the bank under
            the Remittance Facility on submitting the transaction request and successfully
            transferring the funds to the advised account of the bank. In the event the Registered
            User desires to revoke /cancel after successfully submitting the transaction for
            processing, the bank may accept such cancellation at its discretion and on a best effort
            basis, provided that exchange loss incurred by the bank in this connection shall be
            reimbursed. The bank will be entitled to debit such amounts due to the bank from the
            funds paid to the bank by the Registered User for executing such transaction.
            <br />
            Any scheme for awarding or securing reward points or other rewards or prizes (by
            whatever name called) is available only to Persons who are eligible for the same under
            the rules of the concerned scheme and the applicable laws of India and other concerned
            jurisdictions. The Registered User is therefore required to verify the eligibility of
            the Registered User before participating in any such scheme. The bank is not responsible
            or liable for the performance, quality or any other aspect of any rewards, prizes or
            items manufactured or supplied by third parties against any redemption of the points or
            otherwise pursuant to such scheme, and the Registered User's recourse for the same will
            be only against the Persons who have manufactured or supplied the same. The bank shall
            be entitled to have more than one promotional offer in existence and applicable at any
            given time. However, a Registered User shall be entitled to avail of only one offer per
            transaction and in case of multiple transactions under a given offer, he/she shall be
            eligible only for the first eligible transaction. It shall be entirely at the discretion
            of the bank to consider any exceptions to the above.
            <br />
            The bank has no control over, and is not responsible for, the quality, safety, legality,
            or delivery of any goods or services that the Registered User may pay for using the
            Website and/or the facilities. Such use will be at the Registered Users own risk.
            <br />
            In order to avail of specific facilities, the Registered User may have to agree to other
            terms and conditions in addition to the Facility T&C and may also have to execute
            agreements, undertakings, declarations, powers of attorney and other writings and abide
            by the procedures as may be specified by the bank.
            <br />
            The bank retains the right to terminate the registration of any Registered User and
            refuse the Registered User’s access to or use of the Website or any facilities,
            including the cancellation of pending transactions, as per its discretion.
            <br />
            <h4>Disclaimers</h4>
            The Website, all information on or available through the Website and the facilities
            provided by bank are made available to the Registered Users as is and without any
            representation or warranty of any kind, either express or implied, including without
            limitation, any representation or warranty for accuracy, continuity, uninterrupted
            access, timeliness, sequence, quality, performance, fitness for any particular purpose,
            completeness, title, compatibility, warranty of non-infringement, freedom from computer
            virus, warranties of merchantability or fitness for a particular purpose, each to the
            extent permissible by applicable law.
            <br />
            Although the bank adopts security measures that it considers appropriate for the
            Website, it does not represent or warrant that the Website is immune from denial of
            service attacks, unauthorised access or other illegal subversion of these security
            measures that might impair the working of the Website, the availability of the
            facilities or the integrity and confidentiality of Registered User’s personal and login
            information or accounts and the bank disclaims liability arising from any such acts or
            occurrences. Furthermore, while the bank takes reasonable precautions to avoid such
            eventualities, and the Registered User understands that communications through internet
            are not always secure and agrees that the bank shall not be responsible for any
            unauthorised or illegal interception of E-mail or other communication to or from the
            bank.
            <br />
            Services are subject to the activities taken by other international banks and Service
            Providers involved in the wire transfer. The bank disclaims any responsibility for any
            delay or failure caused due to any action of international banks and Service Providers.
            <br />
            Information and facilities on the Website may be displayed and offered in a phased
            manner at the discretion of the bank. The bank shall have the right to, from time to
            time and in its discretion, introduce new information and facilities and add to, modify,
            or withdraw any information or facility or the terms thereof in whole or in part. While
            the bank makes every endeavour to ensure that the facilities are offered to a Registered
            User without interruption or delay, continued provision of the facilities may be
            impractical or impossible due to the failure of operational systems for reasons
            including but not limited to virus attacks, natural calamity, floods, fire and other
            natural disasters, legal restraints, faults in the telecommunication network or network
            failure, system maintenance, software or hardware error, labour problems, strikes or any
            other reason beyond the control of the bank, and the bank makes provides no guarantee
            that any instructions or transactions will definitely be communicated, processed or
            performed (whether or not before a particular time) using the Website or the facilities.
            <br />
            The bank operates and offers the Website and the facilities strictly on a no-liability
            and no-obligation basis as regards the bank, and the bank shall not be liable to the
            Registered User or any other third party for any claim for direct, indirect, incidental,
            special, exemplary, punitive, consequential or other damages (including, without
            limitation, loss of profits, loss or corruption of data, loss of profit or goodwill,
            work stoppage, computer failure or malfunction, or interruption of business) whether
            arising under contract, tort or any other theory arising out of or in connection with
            the Website, the inability to access the Website or any facilities, products or services
            mentioned or advertised on or accessed or availed on or through the Website. The
            Registered Users remedies for errors or unauthorized transactions shall be limited to
            those arising under the applicable laws and regulations, and as described on the Website
            and in the communications provided by the bank to the Registered User.
            <br />
            To the extent any of the disclaimers or limitations of bank’s liability in the Facility
            T&C are held to be unenforceable, the maximum liability of the bank to the Registered
            User shall not exceed the amount of fees paid/payable by the Registered User to the bank
            for the specific facility availed by the Registered User through the Website and under
            an issue.
            <br />
            The Registered User/ Visitor/ Referrer shall ensure that he/she shall not be in
            violation of any data protection laws in force at the time of referring potential users
            for the service to the bank or when registering for the Remittance Facility (as the case
            may be).
            <br />
            <h4> Facilities Provided by Third Parties</h4>
            Some of the facilities mentioned or offered on or through the Website require the
            Registered User to independently contract for and use services provided by third party
            Service Providers and the bank makes no warranty on behalf of such third parties. The
            bank shall not be liable for any loss or damage of any sort incurred as a result of any
            transactions or dealings between the Registered Users and such third party Service
            Providers. The Registered User may be charged for such transactions /dealings by such
            third party Service Provider. Such third party Service Providers may have their own
            agreements, terms and conditions which will govern the services provided by them, which
            may be specific to each such Service Provider and vary from facility to facility. The
            bank recommends that the Registered User obtain the full text of such terms and
            warranties from such Service Providers before availing of any such service. All of the
            Registered User's rights and remedies and all maintenance, update, warranty, liability
            or any other obligations related to any such services shall be governed by the
            applicable terms, policies and procedures of the concerned Service Provider and the bank
            shall not be liable or responsible for the same in any manner. The Registered User shall
            have no claim, rights or remedies whatsoever against the bank in respect of any such
            services availed or sought to be availed by the Registered User from any such Service
            Provider. The Registered User agrees not to hold the bank liable for any loss or damage
            of any sort incurred as a result of any such dealings with any Service Provider.
            <br />
            <h4> Terms of specific facilities</h4>
            The following (among other) facilities are proposed to be offered on the Website.
            However, all the facilities or all the various components and features of a facility may
            not be offered at all times. The bank may discontinue, modify, change, and alter any of
            the features of the facility at its sole discretion.
            <br />
            Alerts: the bank shall endeavour to ensure that Alerts are communicated to the
            Registered User in accordance with the Registered User's instructions. However, neither
            the bank nor the Service Providers would be responsible or liable for non-dispatch or
            delay in dispatch of the Alerts by the bank / Service Providers or any delay in receipt
            or non-receipt of the Alerts for any reason whatsoever. Under no circumstances shall the
            bank and/or the Service Providers be liable for any costs, damages or other amount
            whatsoever for such non-dispatch or delay in dispatch or any non-receipt or delay in
            receipt of the Alerts. Non- receipt of Alerts will not discharge or reduce the
            Registered User's liability to pay any amount to the bank which would have been payable
            in the event of proper receipt of the Alerts.
            <br />
            Remittance Facility: subject to the relevant regulatory approvals, terms and conditions
            imposed while granting the necessary approvals and other terms of the Remittance
            Facility, such facility enables the Registered User to avail of a technology platform
            for initiating outward remittances. The bank shall, under the Remittance Facility,
            convert the funds received from the Registered User in to the relevant currency of the
            Beneficiary as instructed by the Register User.
            <br />
            The Registered User should pay the total remittance amount including any charges and
            taxes as may be applicable, as per the instructions stated on the Website by an
            acceptable mode described on the Website. The funds will be remitted from India only
            after matching the name of the Registered User against the sender name as mentioned in
            the electronic fund transfer message received by the bank. Thereafter, after deducting
            the appropriate charges/fees as may be applicable at the time of remittance, the money
            will be remitted to the Beneficiary Bank account in the Relevant Country as designated
            by the Registered User.
            <br />
            The bank will process the request only upon receipt of clear funds from the remitters
            account and a swift message will be sent to the correspondent bank. The bank will
            provide confirmation on processing the transaction, which shall mean that the bank has
            sent the swift message to the correspondent bank. The bank will not be able to confirm
            whether the Beneficiary account has been credited, however, if the funds are returned,
            then status will be updated accordingly and the funds will be refunded to the same
            account from which funds were received after deducting applicable charges.
            <br />
            The bank will process the remittance request only if the funds are received in the
            designated account of the bank within the validity period as mentioned on submitting the
            transaction along with the transaction's unique reference number. In the event, the
            funds are received after the validity period the bank reserves the right to cancel the
            transaction as per its sole discretion. Validity period for the purpose of this clause
            shall mean the period up to which the funds are received by the bank for processing the
            transaction. On expiry of the validity period, the bank reserves the right to either
            process the transaction on receiving the funds at the prevailing exchange rate
            applicable at the time of conversion or may reject the transaction and return the funds
            to the remitting account at its sole discretion.
            <br />
            While it shall be the bank's endeavour to adhere to the time schedule indicated by it on
            the Website, the bank hereby disclaims liability or responsibility for any changes in
            the time schedule for execution of the Registered User's instructions or remittance or
            credit of funds for any reason, except as otherwise required by applicable law or
            regulation and as described to the Registered User on the Website and in communications
            provided by the bank to the Registered User. The bank shall in no way be held
            responsible and/or be liable for any queries, errors, disputes or delays in messaging,
            money transmission, currency conversion, conversion rates offered, payment to the
            beneficiaries of the remittances or any other query, claim or dispute.
            <br />
            The bank will, however, use reasonable efforts to assist the Registered User in
            contacting the bank or any third party to facilitate resolution of such queries, claims
            and disputes. The Registered User hereby authorizes the bank to check or to use a third
            party agency to check the Registered User's credit history/identity details at the time
            of and/or prior or subsequent to enrolment. The Registered User hereby agrees that,
            where the bank so deems advisable or necessary as per its due diligence criteria, the
            bank may hold the money (to be remitted to the Relevant Country) for longer than the
            usual time for remittance, and may delay the remittance. The Registered User hereby
            agrees that the bank has no control over when the Beneficiary's financial institution
            (through whom the Beneficiary chooses to receive the remittance) makes such funds
            available for the Beneficiary's use and the bank shall not be responsible for any delay
            or default on the part of such financial institution.
            <br />
            The Registered User hereby agrees that the purpose of the remittances supported by the
            Remittance Facility will be strictly limited to the purposes as permitted on the Website
            at the time of using the Remittance Facility. The purpose declared by the Registered
            User while using the Remittance Facility will be treated as final and binding and cannot
            be changed at a later date by the Registered User or the intended Beneficiary.
            <br />
            The regulatory reporting by the bank in India will be done on the basis of the purpose
            selected by the Registered User through the Remittance Facility. The Registered User
            shall provide to the bank all the information as may be required, in absence of which
            the Registered User shall not avail of the Remittance Facility. The Registered User
            hereby undertakes that by sending funds to the Relevant Country , he/she is not
            violating any exchange control laws stipulated by the Government of India and/or the
            Reserve Bank of India and the rules prevailing in such destination country.
            <br />
            The Registered User agrees to keep the bank indemnified for any such violation the
            Registered User hereby acknowledges that the obligation shall lie on the Registered User
            to ensure that there are no violations of any law, regulation, authorization including
            the limits on outward remittances listed in the Foreign Exchange Management Act, 1999 of
            India or exchange control and the Registered User shall be solely liable for any
            violation thereof.
            <br />
            The Registered User hereby agrees and acknowledges that the maximum value for any
            remittance transaction or the cumulative values of a number of remittance transaction
            using the Remittance Facility shall not exceed the limit of USD 250,000 for a particular
            financial year or such other limit that may be communicated by the bank to the
            Registered User from time to time. Besides, the Registered User will be able submit
            requests for foreign outward remittance through net-banking within the applicable
            third-Party funds transfer limit only, as applicable to his/her account.
            <br />
            By agreeing to these Terms and Conditions, the user/customer, hereby provide his/her
            explicit consent for Unobanc to use his digital signature on all documents necessary \
            for the processing of transactions related to the services provided by the Unobanc. This
            consent includes transaction-related documents that require your signature for the
            purpose of conducting business electronically.
            <br />
            User/Customer hereby acknowledge and agree that his/her digital signature, once affixed
            to a document, shall be considered as valid, binding, and enforceable as his/her
            handwritten signature. User/Customer further agree that they will not dispute the
            legality, validity, or enforceability of any transaction or document solely because a
            digital signature was used in its execution.
            <br />
            This consent remains in effect until expressly revoked in writing, subject to any
            completed or pending transactions initiated prior to the revocation of consent.
            Revocation of this consent may result in the termination of your ability to transact
            electronically with Unobanc.
            <br />
            The bank may specify to the Registered User through the Website from time to time the
            limit on the funds that can be transferred from the Registered Users account to the
            Beneficiary account. The Registered User acknowledges that he/she has read, understood
            and complied with all laws and regulation including those mentioned in the Declaration
            and the bank shall not be responsible for any non-compliance of the limits mentioned
            therein by the Registered User. <br />
            The bank shall assume no responsibility for the performance of any entity involved in
            the process; and for any loss or damage incurred or suffered by the Registered User for
            any error, defect, failure or interruption of the facility or consequences arising out
            of delayed payments. The bank shall not be responsible for impounding of funds by any
            regulators/ regulatory authority in the Relevant Country.
            <br />
            <h4>Others</h4>
            <br />
            The Registered User understands that submission of request does not necessarily imply
            processing of the transaction. The bank has full rights to reject the transaction based
            on regulatory and internal guidelines. The Registered User will ensure that the limit
            submitted is correct and has not been exhausted in the current financial year for any of
            the accounts held individually or collectively with any bank. The Registered User
            authorizes the bank to debit the savings bank account together with applicable charges
            and effect the foreign exchange remittance directly (applicable only for SBM Bank India
            account holders).
            <br />
            The Registered User understands that on submitting the request if the transaction
            reference number is not displayed then the user should check if the E-mail or SMS
            confirmation is received by him/her for successful submission of the request. Applicable
            for SBM Bank India account holders only. The Registered User understands that on
            submitting the request if the service request number is not displayed then he should
            check if the email confirmation is received for successful submission of the request and
            should check if the debit is posted in the account. Any re-initiation without confirming
            will result in duplicate debit into his/her account. The Registered User agrees to
            adhere to the turn-around time and cut off timings for raising the request.
            <br />
            Funding the account for remittance to be processed as per informed timelines on the
            Website the above cut off timing is applicable on working days (presently Monday to
            Friday excluding bank holidays in India and the country of remittance). The Registered
            User confirms that he/she is not a foreign national. Further, this facility is only for
            telegraphic transfer/wire transfer. The Registered User agrees and acknowledges that the
            bank is not liable in case the funds are not credited or credited with the delay for any
            reason at Beneficiary Bank/intermediary bank's end for any query or suggestion kindly
            contact our customer service desk. The exchange rate applicable to the remittance
            request will be applicable only if the designated account of the bank is funded by the
            Registered User within the validity period. The bank will process the transaction
            request only if the funds are transferred from a self-resident savings account of the
            remitter, in case the funds are transferred from a joint account, the Registered User
            must be the primary account holder and does not require any permission from the joint
            account holder. If the funds are received from an account where the Registered User is
            not primary account holder and the name does not appear in the fund transfer details
            received from his/her bank, bank would reject such transaction and return the funds
            within 7 working days.
            <br />
            <h4> Referral Transactions</h4>
            The transactions in relation to the recommendations/ referrals made by the Referrer will
            be bank’s transactions (“Referral Transactions”) and the Referrer understands that any
            decision made by the bank in relation to the Referral Transactions shall be final.
            <br />
            The Referrer agrees to assist and conduct its searches to confirm the legality and
            validity of the KYC documents in relation to the Referral Transactions in accordance
            with the instructions provided by the bank. The bank will be responsible for the
            compliance of the KYC Master Directions (Master Direction DBR.AML.BC.
            No.81/14.01.001/2015-16) for the purpose of such Referral Transactions.
            <br />
            Further, the Referrer agrees to provide any other information/documents in relation to
            the individuals or Persons referred by it as may be stipulated by the bank from time to
            time and the bank in its sole discretion may accept/reject any referral made by the
            Referrer and the bank will have absolute discretion to use the referral in any manner it
            deems appropriate and for any of the products or services offered by the bank or the
            subsidiaries / Referrers of the bank.
            <br />
            The Referral Transactions will be subject to applicable Nostro Account charges for the
            payments made to the Beneficiary and shall be in accordance with Article 3.
            <br />
            The Alliance Partner will not be held liable for any claims/complaints or liabilities
            arising in relation to the Referral Transactions.
            <br />
            If a Person/ customer/ Referrer’s complaint comes to the Alliance Partner, the Alliance
            Partner will within 1 (one) business day transfer the complaint to the bank.
            <br />
            Any refund under the Referral Transaction will be on the basis of return credit received
            in the Nostro Account, and subject to deduction of any conversion charges and in
            accordance with Article 3. In case of any refunds due to return from overseas, the
            customer fee, GST, Tax Collected at Source (“TCS”) or any other amounts will not be
            refunded.
            <br />
            Standard charges applicable and also corresponding taxes will be applicable upon
            refunds, while converting the amount back to Indian currency, in accordance with Article
            3.
            <br />
            TCS collected by bank under the Referral Transactions, will not be refunded under any
            circumstances and the customer/ Registered User/ Person may adjust the same during their
            ITR filing.
            <br />
            Customer/ Registered User will be responsible for correctness of the information
            provided for the Referral Transaction, any rejection/delay due to incorrect details
            provided, will not be the responsibility of the bank or the Alliance Partner.
            <br />
            The customer declaration taken from the customer, shall be correct and the customer
            shall be responsible for the correctness of the same.
            <br />
            The Customer will make payments in relation to the Referral Transactions from its own
            account, any payment made by a third-party account will be rejected by the bank.
            <br />
            <br />
            Permissible Outward Remittance Payments
            <br />
            The Registered User agrees that it will only request a remittance payment that complies
            with the Facility T&C and the applicable laws of India and applicable law in the
            Relevant Country of the Beneficiary. The Registered User may use the Remittance Facility
            to send remittance payments on its own behalf. The Registered User may not resell the
            Registered User Account access or use the Remittance Facility to make remittance
            payments on behalf of, or as agent for, another Person. The Registered User undertakes
            that the bank account, details provided to the bank, pertain to his/her own resident
            savings bank account, and the funds being remitted are his/her own funds and such funds
            and are not originating from an NRO (non-resident ordinary) account. The Registered User
            agrees that it will not request a remittance payment that would result in a violation of
            the laws or regulations of India and/or applicable law in the country of the
            Beneficiary.
            <br />
            <h4> Proprietary and Intellectual Property Rights</h4>
            The bank is the owner and/or authorized user of any trademark, registered trademark
            and/or service mark appearing on the Website, and is the copyright owner or licensee of
            the content and/or information on the Website including but not limited to any text,
            links, images, logos, illustrations, audio clips, video clips, screens and product and
            Registered Users or any Visitor shall not download and/or save a copy of the Website or
            any part thereof including any of the screens or part thereof and/or reproduce, store it
            in a retrieval system or transmit it in any form or by any means - electronic,
            electrostatic, magnetic tape, mechanical printing, photocopying, recording or otherwise
            including the right of translation in any language without the express permission of the
            bank (except as otherwise provided on the Website or in the Facility T&C for any
            purpose) or use or modify it in any manner that is likely to cause confusion or
            deception among Persons or in any manner disparages or discredits the bank or any
            Service Providers. However, Visitors may print a copy of the information on this Website
            for the Personal use or records. The bank, the Alliance Partners and/or the Service
            Providers do not grant any license to or other authorization, and none should be implied
            or presumed, for use of their respective trademarks, registered trademarks, service
            marks, or other copyrightable material or other intellectual property by placing them on
            the Website.
            <br />
            This Website is for the Visitors personal use. If the Visitor makes any other use of
            this Website, except as otherwise provided above, the Visitor may violate copyright,
            trademark and other laws of India and other countries, and may be subject to penalties.
            <br />
            <h4> Use of Information</h4>
            By agreeing to the Facility T&C, the Registered User and the Visitor consents to the
            banks privacy policy, a copy of which may be found on the Website.
            <br />
            The Registered User/ Visitor undertakes and authorises the bank, its group companies to
            exchange, share or part with all the information, data or documents relating to his/her
            application to other SBM Bank India group companies / banks / financial institutions /
            credit bureaus / agencies / statutory bodies /tax authorities /central information
            bureaus/ such other Persons as the bank / its group companies may deem necessary or
            appropriate as may be required for use or processing of the said information / data by
            such Person/s or furnishing of the processed information / data / products thereof to
            other banks / financial institutions / credit providers / users registered with such
            Persons and shall not hold the bank and/ or its group companies liable for use of this
            information. I/ we hereby irrevocably authorise the bank to extract my/our call records
            or related information as may have been disclosed by me/ us with/ to any third party
            Service Providers in relation to services and facilities offered to me/us by such third
            party Service Providers on account of my/ our existing banking relationship with the
            bank.
            <br />
            From time to time, it will be necessary for Registered User(s)/ Visitors to supply the
            bank with data in connection with the opening or continuation of accounts or the
            provision of services and facilities. Failure to supply such data may result in the bank
            being unable to provide any of the above services or facilities. It is also the case
            that data is collected from Registered User/ Visitors in the ordinary course of banking
            relationship, for example, when Registered User/ Visitors write cheques, deposit money
            or apply for credit. This includes information obtained from credit reference agencies.
            <br />
            The purpose(s) for which Registered User/ Visitor data may be used are as follows: i.
            The processing of applications for, and the daily operation of the services and credit
            facilities provided to Registered User/ Visitors; ii. Conducting credit checks
            (including without limitation upon an application for consumer credit and upon periodic
            review of the credit) and data verification; iii. Assisting other financial institutions
            to conduct credit checks and collect debts; iv. Ensuring ongoing creditworthiness of
            Registered User/ Visitors; v. Designing financial services or related products for
            Registered User/ Visitors' use; vi. Marketing financial services or related products to
            Registered User/ Visitors; vii. Determining the amount of indebtedness owed to or by
            Registered User/ Visitors; viii. Creating and maintaining the bank's credit and risk
            related models; ix. Collection of amounts outstanding from Registered User/ Visitors and
            bills providing security for Registered User/ Visitors obligations; x. Meeting the
            requirements to make disclosure under the requirements of any law, rule, regulation,
            order, ruling, judicial interpretation or directive (whether or not having the force of
            law) applicable to the bank or (any of its branches) and its agents and affiliates; xi.
            Enabling an actual or proposed assignee of the bank, or participant or sub participant
            of the bank's rights in respect of the Registered User/ Visitor to evaluate the
            transaction intended to be the subject of the assignment, participation or sub
            participation; xii. Any other purposes permitted by law; and xiii. Purposes relating to
            any of the above.
            <br />
            Data held by the bank relating to Registered User/ Visitors will be kept confidential
            but the bank may, at its sole discretion, provide such information to the categories of
            Persons set out below. The Registered User/ Visitor hereby irrevocably authorises the
            bank to disclose, as and when the bank is required to do so by applicable law or when
            the bank regards such disclosure as necessary or expedient (including but not limited to
            disclosures for the purpose of credit review of any account or the facilities availed by
            the Registered User/ Visitor with the bank or any of its branches whether singly or
            jointly with others or otherwise), any information relating to the Registered User/
            Visitor, his account(s) or other assets or credit facilities whatsoever held on the
            Registered User/ Visitor's behalf to:- i. The head office, affiliates or any other
            branches or subsidiaries of the bank; ii. His auditors, professional advisers and any
            other Person(s) under a duty of confidentiality to the bank; iii. Vendors, installers,
            maintainers or servicers of the bank's computer systems; iv. Any exchange, market, or
            other authority or regulatory body having jurisdiction over the bank, its head office or
            any other branch of the bank or over any transactions effected by the Registered User/
            Visitor or for the Registered User/ Visitor's account; v. Any party lawfully authorised
            by law to make such demand or request; vi. Any Person with whom the bank contracts or
            proposes to contract with regard to the sale or transfer or sharing of any of its
            rights, obligations or risks under the Facility T&C; vii. Any Person (including any
            agent, contractor or third party Service Provider) with whom the bank contracts or
            proposes to contract with regard to the provision of services and/or facilities in
            respect of the Registered User/ Visitor's (as the case may be) or in connection with the
            operation of the bank's business; viii. Any Person employed with, or engaged as an agent
            by, the bank or its head office or affiliates, including any relationship officers,
            whether in India or elsewhere, for the purposes of or in connection with interactions
            with the Registered User/ Visitors or providing services to the Registered User/
            Visitors or processing transactions pertaining to the Registered User/ Visitors'
            accounts or facilities; ix. (to enable the bank to centralise or outsource its data
            processing and other administrative operations) to the bank's head office, its
            affiliates or third parties engaged by the bank for any such services/operations; x. In
            case of a wire transfer to the Beneficiary Bank to whom the transfer is being made. Xi.
            A drawee bank providing a copy of a paid cheque (which may contain information about the
            payee) to the drawee; xii. A Person making payment into the Registered User/ Visitor's
            account (by providing a copy of a deposit confirmation slip which may contain the name
            of the Registered User/ Visitor); xiii. Credit reference agencies and, in the event of
            default, debt collection agencies; xiv. Any Person to whom the bank is under an
            obligation to make disclosure under the requirement of any law binding on the bank or
            any of its branches; and xv. Any Person to whom disclosure may be required by applicable
            law and regulation.
            <br />
            The Registered User/ Visitor hereby agrees and consents that the bank shall be entitled,
            in connection with the Registered User/ Visitor's application for any account,
            facilities or services provided by the bank, or during the course of the Registered
            User/ Visitor's relationship with the bank, to obtain and procure information pertaining
            to the Registered User/ Visitor any of his/ her/ its accounts, legal or financial
            position from whatever sources available to the bank.
            <br />
            Data may be transferred overseas pursuant to the provisions of this clause. The
            information disclosed pursuant to this clause may be subject to further disclosure by
            the recipient to other parties in accordance with the laws of the country in which the
            recipient is located. Such laws may be wider in scope and implemented under less
            restrictive terms than would otherwise be the case in India due to the difference in
            applicable laws and regulations.
            <br />
            <h4> No Agency or Banking Relationship</h4>
            The Facility T&C and the use by the Registered User or access to the Website or any
            facilities are not intended to create an agency, partnership, joint-venture,
            employer-employee or banker-customer relationship between the Registered User or the
            Beneficiary of the one part and the bank or Service Provider of the other part, except
            where otherwise specifically agreed or appointed. Specifically, the use of Remittance
            Facility does not establish a checking account or any other form of a bank account for
            the Registered User or the Beneficiary with the bank and neither does it constitute or
            create a fiduciary or escrow capacity between the Visitor or the Beneficiary and the
            bank. Funds held while processing a remittance payment request are not insured by any
            government authority. None of the facilities offered hereby is a funds transfer or
            transmission service, and a Registered User’s request or instruction while using a
            facility is not a payment order or other request for a funds transfer.
            <br />
            <h4>Indemnity</h4>
            Each Visitor and/or Registered User agrees to defend, indemnify and hold the bank, and
            Service Providers and each of their respective affiliates, directors, officers and
            employees, harmless from any and all claims, liabilities, damages, costs, expenses and
            proceedings, including reasonable attorneys' fees, arising in any way from the Visitors
            or Registered User's use of the Website, whether in India or any other jurisdiction, the
            inaccuracy or incompleteness of registration information, or the placement or
            transmission of any message, information, software or other materials through the
            Website by the Visitor, the Registered User or users of the Registered User's ID and
            password or related to any violation of the Facility T&C by the Visitor or Registered
            User or users of the Registered User's ID and password, and any claims dispute or
            differences between the Visitor or Registered User and any supplier of services that are
            part of the facilities.
            <br />
            The Registered User hereby agrees unconditionally to indemnify the bank and hold the
            bank harmless against any liability, costs, damages, claims, suits, and proceedings
            based upon or relating to such untrue/false/misleading information.
            <br />
            <h4> Suspension or Termination of Access</h4>
            The Registered User acknowledges and agrees that the bank may, without notice, suspend
            or terminate the Registered User's ID, password or account or deny the Registered User
            access to all or part of the Website or any facilities if the Registered User engages in
            any conduct or activity that the bank, in its sole discretion, believes violates any of
            the Facility T&C, violates the rights of the bank, or is otherwise inappropriate for
            continued access, or if the bank learns of the Registered User's death, bankruptcy or
            lack of legal capacity or of circumstances that impact the Registered User's
            creditworthiness or for any other reason which the bank thinks fit and proper.
            <br />
            Until suspension or termination of the Registered User’s ID takes effect, the Registered
            User will remain responsible for any transactions entered into using the Registered
            User’s ID and all obligations incurred thereby or otherwise by the Registered User.
            <br />
            <h4> Governing Law and Jurisdiction</h4>
            The Website, the facilities, the Facility T&C, all transactions entered into on or
            through the Website or through the availment of any facility and the relationship
            between the Registered User/Visitor and the bank shall be governed by and construed in
            accordance with the laws of India and no other nation, without regard to the laws
            relating to conflicts of law. The Registered User and the bank agree that all claims,
            differences and disputes (collectively, “Disputes”) arising under or in connection with
            or pursuant to the Website, the availment of any facility, the Facility T&C, any
            transactions entered into on or through the Website or through the availment of any
            facility or the relationship between the Registered User and the bank shall be subject
            to the exclusive jurisdiction of the competent courts located in the city of Mumbai,
            Maharashtra, India and the Registered User hereby accedes to and accepts the
            jurisdiction of such courts. Notwithstanding the aforementioned, if the bank thinks fit,
            the bank may institute proceedings against a Registered User in any other court or
            tribunal having jurisdiction under applicable law. Disputes shall include not only
            claims made directly by the Visitor, but also made by anyone connected with the Visitor
            or claiming through a Visitor, such as a recipient of funds. Disputes include not only
            claims that relate directly to the bank, but also its successors, assignees, employees,
            and agents, and claims for which the bank may be directly or indirectly liable, even if
            it is not properly named at the time the claim is made. Disputes include claims based on
            any theory of law, contract, statute, regulation, tort (including fraud or any
            intentional tort), or any other legal or equitable ground. Disputes include claims made
            as part of a class action or other representative action, it being expressly understood
            and agreed to that the resolution of such claims must proceed on an individual
            (non-class, non-representative) basis.
            <br />
            The bank hereby disclaims all liability, direct or indirect, for non-compliance with the
            laws of any jurisdiction other than India. The fact that it is technologically possible
            to access or use the Website and avail of any facility in any jurisdiction other India
            should not in itself suggest that it is legal to do so. It shall be the sole
            responsibility of the Visitor to verify whether the Website and the facilities can be
            legally and legitimately accessed, utilized and availed in the relevant jurisdiction and
            the Visitor understands that by accessing, using and availing of the Website and the
            facilities, he or she may be violating the local laws in India and/or such jurisdiction.
            Further, the bank hereby explicitly disclaims any responsibility, direct or indirect,
            for non-compliance by a Visitor of the laws of any jurisdiction whatsoever.
            <br />
            <h4> No Waiver</h4>
            The failure or delay of the bank to exercise or enforce any right or provision of the
            Facility T&C shall not constitute a waiver of such right or provision. No waiver on the
            part of the bank shall be valid unless it is in writing signed by or on behalf of the
            bank. A waiver of any right or provision by the bank on a particular occasion shall not
            prevent the bank from enforcing such right or provision on a subsequent occasion.
            <br />
            <h4>Severability</h4>
            <br />
            If any provision of the Facility T&C shall be held to be invalid or unenforceable by
            reason of any law or any rule, order, judgement, decree, award or decision of any court,
            tribunal or regulatory or self-regulatory agency or body, such invalidity or
            unenforceability shall attach only to such provision or condition, and the Visitor,
            Registered User, the bank, the court, tribunal or regulatory or self-regulatory agency
            or body should endeavour to give effect to the parties' intentions as reflected in the
            provision to the extent possible. The validity of the remaining provisions and
            conditions shall not be affected thereby and these Facility T&C shall be carried out as
            if any such invalid or unenforceable provision or condition was not contained herein.
            <br />
            <h4>Limitation</h4>
            <br />
            Notwithstanding any statute or law to the contrary, but to the extent permitted by law,
            any claim or cause of action arising out of or related to access or use of the Website
            or any facility or the Facility T&C must be filed within three (3) months after such
            claim or cause of action arose failing which it shall be forever barred.
            <br />
            <h4>Notices</h4>
            <br />
            The bank may give notice to the Registered User by E-mail, letter, telephone or any
            other means as the bank may deem fit to the address last given by the Registered User.
            Notices under the Facility T&C may be given to the bank by the Registered User in
            writing by delivering them by hand or by sending them by post to the bank's address
            mentioned on the Website. The bank may, but shall not be bound to, act upon notices and
            instructions given by the Registered User to the bank by E-mail, letter, telephone or
            any other means as the bank may deem fit.
            <br />
            In addition, the bank may (but shall not be bound to) also publish notices of general
            nature, which are applicable to all Visitors and/or Registered Users in a newspaper
            circulating in India and/or on its Website. Such notices will have the same effect as a
            notice served individually to each Visitor and/or Registered User.
            <br />
            Documents which may be sent by electronic communication between the parties may be in
            the form of an e-mail, an e-mail attachment, or in the form of an available download
            from the Website. The bank shall be deemed to have duly communicated and delivered any
            communication or document to the Registered User if such communication or document is
            sent via e-mail to the e-mail address provided by the Registered User to the bank. The
            bank shall also be entitled to act on the basis of any instructions received or
            purported to be received by the bank from the Registered User by e-mail or other
            electronic means or via the internet. The bank shall also be entitled (but not bound) to
            act upon fax instructions and communications.
            <br />
            <h4>Miscellaneous</h4>
            <br />
            The bank may sub-contract or employ agents to carry out any functions or services
            relating to the Website, any facility or any of its obligations under the Facility T&C.
            <br />
            In order to access the Website and avail of the facilities, the Visitor will, at the
            Registered Users own cost, have to: i. Obtain access to the world wide web and pay any
            service fees, telephone charges and online service usage associated therewith, and; ii.
            Obtain access to all equipment necessary for the Registered User to connect to the world
            wide web, including a computer and modem.
            <br />
            The content presented on or through the Website may vary depending upon the Visitors
            browser limitations and the bank disclaims any responsibility for the unavailability of
            any facility or any error in processing of a transaction through the Website caused by
            the Visitors browser limitations.
            <br />
            All communications under these Facility T&C shall be conducted in the English language.
            <br />
            <h4> Definitions and Interpretations</h4>
            In these Facility T&C, unless the context otherwise requires, the following words and
            phrases shall have the meanings assigned to them hereunder:
            <br />
            "Alerts" means notices relating to various matters issued or to be issued by the bank to
            the Visitor from time to time e.g. notices of market information, reminders for bill
            payments, etc.
            <br />
            "Alliance Partner" means any Person, other than the bank, who displays content or offers
            any facility on the Website.
            <br />
            "Beneficiary" means a person resident outside India as defined in Foreign Exchange
            Management Act (FEMA), 1999, for all purposes except for remittance to own account
            abroad and whose details have been provided by the Registered User to the bank for the
            transfer of funds.
            <br />
            "Beneficiary Bank" means the bank in the Relevant Country, with whom the Beneficiary
            holds an account, and which has been so mentioned by the Registered User.
            <br />
            "Call Centre" means the call centre which may be set up by the bank or a Service
            Provider to assist Visitors/Registered Users in connection with the Website including
            the facilities displayed or offered thereon and any transactions entered into or
            proposed to be entered into by the Visitors in respect of such facilities.
            <br />
            "Declaration" means a declaration submitted by the Registered User at the time of
            registration and transaction in the form and manner acceptable to the bank.
            <br />
            “Nostro Account” means a bank account established in a foreign country usually in the
            currency of that country for the purpose of carrying out transactions there.
            <br />
            "Person" includes a resident individual.
            <br />
            "Referrer" means an individual or a Person, who may be an existing Registered User, who
            refers/recommends/suggests to another individual or Person the services offered by the
            bank, irrespective of whether the concerned individual/Person avails the service.
            <br />
            "Registered User" means any Visitor who has registered himself, herself or itself with
            the Website in the appropriate manner or utilises service offered through this Website
            by the virtue of holding a bank account with the bank.
            <br />
            "Registered User Account" means an online account created by Registered User on the
            Website to avail the Remittance Facility.
            <br />
            "Registered User ID" means the username that is chosen by the Registered User and
            registered by the Website which, along with the Registered User Password, will enable
            the Registered User to - Avail of facilities and enter transactions in respect of the
            facilities; Access its Registered User Accounts, download application forms for
            facilities and register a change in address; and Do any other acts as the Website may
            permit.
            <br />
            "Registered User Password" means the password that is chosen by the Registered User and
            registered by the Website for access to the Website which, along with the Registered
            User ID, will enable the Registered User to - Avail of facilities and enter transactions
            in respect of the facilities offered on the Website; Access its Registered User
            Accounts, download application forms for facilities change in nominee details, payments,
            payment of dues, bill payments, trading and make online applications register a change
            in address; and Do any other acts as the Website may permit.
            <br />
            "Relevant Country” means a country where the Registered User may transfer funds to the
            Beneficiary under the Remittance Facility.
            <br />
            "Remittance Facility" means an instruction for transfer of funds from the Registered
            Users account in India to a Beneficiary in Relevant Country through the Website for
            select purposes detailed herein, the services provided by the bank on the Website for
            the transmission of funds by a Registered User to a Beneficiary in the Relevant Country.
            <br />
            "Service Provider" means a Person who provides a service to the bank in order to enable
            the bank to operate and/or maintain the Website, provide any feature on the Website or
            provide any facility which is provided by the bank.
            <br />
            "Visitor" means any Person who accesses or visits the Website, whether or not such
            Person has registered himself as a Registered User.
            <br />
            In these Facility T&C, unless the context otherwise requires: Words of any gender are
            deemed to include each other gender; Words using the singular or plural also include the
            plural or singular, respectively; The terms "hereof", "herein", "hereby", "hereto" and
            derivative or similar words refer to this entire Website; The term "article" refers to
            the specified clause of these Facility T&C; Headings and bold typeface are only for
            convenience and shall be ignored for the purposes of interpretation; Reference to any
            legislation or law or to any provision thereof shall include references to any such law
            as it may, after the date hereof, from time to time, be amended, supplemented or
            re-enacted, and any reference to a statutory provision shall include any subordinate
            legislation made from time to time under that provision; Any term or expression used but
            not defined herein or under the terms shall have the same meaning attributable to it
            under applicable law; References to the word "include" or "including" shall be construed
            without limitation.
            <br />
            <h3> DECLARATIONS</h3>
            <h4> Financial limits and Declarations:</h4>
            I hereby declare that:
            <br />
            I am a resident Indian.
            <br />
            I am not a holder of the Beneficiary’s account to which the remittance is being made,
            except for remittances sent under the purpose of "remittance to own account abroad".
            <br />
            The total amount of foreign exchange purchased from or remitted through, all sources in
            India during this financial year including this proposed remittance is within USD
            250,000 (USD two hundred and fifty thousand only) the limit prescribed by Reserve Bank
            of India for the said purpose under the Foreign Exchange Management Act, 1999.
            <br />
            {/* new T&C Clauses added */}
            Foreign exchange proposed to be remitted from SBM Bank India is for the purpose
            mentioned in this application.
            <br />
            The transaction, details of which are specifically mentioned in the application, does
            not cross the limit for the financial year or any other limit prescribed by the Reserve
            Bank of India under the Foreign Exchange Management Act, 1999 for the said purpose.
            <br />
            I am aware that the Finance Act, 2015 has amended Section 195(6) of the Income Tax Act,
            1961 whereby the person responsible for making any payments to non-residents, whether or
            not chargeable to tax in India, is compulsorily required to furnish information in such
            form and manner as may be prescribed. I am aware of the penal provisions that would be
            applicable to me/us as a remitter in case of non-compliance. However, the rules
            prescribing the forms have not been notified by Central Board of Direct Taxes (CBDT)/
            Finance Ministry.
            <br />
            Currently, Rule 37bb prescribing requirement for furnishing of Form 15ca and certificate
            in Form 15cb is applicable only in respect of payment chargeable to tax. In my view, the
            current Rule 37 bb is not applicable for payments which are not chargeable to tax and
            hence, I am unable to comply with the requirement for the payment not chargeable to tax
            until the new rules are notified by the CBDT/ Finance Ministry.
            <br />
            I hereby confirm that amount to be remitted is not chargeable to be taxed in India.
            Therefore, Form 15ca and Form 15cb as per provisions of Rule 37bb of the Income Tax
            Rules, 1962 are not required to be submitted. In the event if there is any income tax
            query/inquiry/notice demanding details/information in India in respect of this
            particular remittance, I/we undertake to provide all the necessary information/document
            to SBM Bank India as required by the Income Tax Department. Further, I/we shall
            indemnify SBM Bank India for any tax/interest or penalty levied by the Income Tax/Income
            Tax Appellate Authorities/courts in India for non-deduction of tax or non-compliance
            with the relevant provisions of income tax law in regard to this remittance.
            <br />
            I, hereby confirm that in case it has been identified at any time during the financial
            year, that I have breached the permissible limit of remittances under the extant
            regulations then SBM Bank India will not be responsible for any such breach by me and I
            agree to adhere to the penal provisions prescribed by the Reserve Bank of India in this
            regard.
            <br />
            In the event if there is any enquiry from any statutory/regulatory authorities in
            respect of this particular remittance, I undertake to provide all the necessary
            information/document(s) to SBM Bank India as may be required in this regard.
            <br />
            Further, I undertake to indemnify SBM Bank India for any tax/interest or penalty levied
            by the Income Tax/Income Tax Appellate Authorities/courts in India for non-deduction of
            tax or non-compliance with the relevant provisions of income tax law with regard to this
            remittance.
            <br />
            I, being a Person resident in India, hereby declare that transaction proposed to be done
            under the liberalized remittance scheme, issued and amended by the Reserve Bank of India
            from time to time, is not in the nature of remittance for margins or margin calls to
            overseas exchanges/overseas counter party or for purpose prohibited transactions under
            the Foreign Exchange Management Act, 1999 or any rules, regulations or guidelines issued
            under the said act, like remittances for purchase of FCCBs issued by Indian companies in
            overseas secondary markets, remittance for foreign exchange trading abroad, etc.
            <br />
            <h3> DECLARATION ON PROHIBITED TRANSACTIONS</h3>
            <h4> Financial limits and Declarations:</h4>
            <br />I hereby declare that the proposed remittance does not involve, and is not
            designed for any purpose for which the drawal of foreign exchange is prohibited viz
            travel to Nepal and/or Bhutan, a transaction with a Person resident in Nepal or Bhutan
            and those under Rule 3 and transactions which require prior approval of the Central
            Government under Rule 4 of the Foreign Exchange Management (Current Account
            Transactions) Rules, 2000 read with Schedule I and Schedule II thereof viz,
            <h4> Prohibited transactions:</h4>
            Remittance out of lottery winnings.
            <br />
            Remittance of income from racing/riding etc. or any other hobby.
            <br />
            Remittance for purchase of lottery tickets, banned/proscribed magazines, football pools,
            sweepstakes, etc.
            <br />
            Payment of commission on exports made towards equity investment in joint ventures /
            wholly owned subsidiaries abroad of Indian companies.
            <br />
            Remittance of dividend by any company to which the requirement of dividend balancing is
            applicable.
            <br />
            Payment of commission on exports under Rupee State Credit Route, except commission up to
            10% of invoice value of exports of tea and tobacco.
            <br />
            Payment related to "Call Back Services" of telephones.
            <br />
            Remittance of interest income on funds held in Non-Resident Special Rupee (Account)
            Scheme.
            <br />
            <h4> Transactions requiring prior approval of central government</h4>
            <h4> Cultural tours.</h4>
            Advertisement in foreign print media for the purposes other than promotion of tourism,
            foreign investments and international bidding (exceeding USD 10,000) by a State
            Government and its public sector undertakings.
            <br />
            Remittance of freight of vessel chartered by a public sector undertaking.
            <br />
            Payment of import through ocean transport by a Government Department or a public sector
            undertaking on C.F.I basis (i.e. other than F.O.B. and F.A.S basis).
            <br />
            Multi-modal transport operators making remittance to their agents abroad.
            <br />
            Remittance of hiring charges of transponders by a) tv channels b) internet service
            providers.
            <br />
            Remittance of container detention charges exceeding the rate prescribed by the Director
            General of Shipping.
            <br />
            Remittance of prize money/sponsorship of sports activity abroad by a person other than
            international / national / state level sports bodies, if the amount involved exceeds USD
            100,000.
            <br />
            Remittance for membership of P&I Club.
            <br />
            <h4> Other Declarations:</h4>I hereby declare that the purpose of remittance and
            transaction details as mentioned above are true to the best of my knowledge and does not
            involve, and is not designed for the purpose of any contravention or evasion of the
            provisions of the Foreign Exchange Management Act, 1999 or any rule, regulation,
            notification, direction or order made thereunder. I agree that I shall be responsible
            and liable for any incorrect detail provided by me. I also hereby agree and undertake to
            give such information/documents as will reasonably satisfy SBM Bank India about this
            transaction in terms of the above declaration. I further agree that once the funds
            remitted by me have been transmitted by SBM Bank India to the correspondent and/or
            Beneficiary Banks, SBM Bank India shall not be responsible for any delays in the
            disbursement of such funds including the withholding of such funds by the correspondent
            and/or Beneficiary Banks. I agree that in the event the transaction gets rejected by the
            Beneficiary Bank because of any incorrect information submitted by me then any charges
            levied by the Beneficiary Bank and/or intermediary bank and exchange loss incurred in
            this connection can be recovered by SBM Bank India from the amount returned by the
            correspondent bank. I also understand that if I refuse to comply with any such
            requirement or make any unsatisfactory compliance therewith, SBM Bank India shall refuse
            to undertake the transaction and shall, if it has reason to believe that any
            contravention/evasion is contemplated by me, report that matter to the Reserve Bank of
            India. I agree that in the event the transaction is cancelled or revoked by me after
            submitting the request for processing to SBM Bank India, which the bank may accept at
            its discretion and on a best effort basis, any exchange loss incurred in this connection
            can be debited from the funds paid to SBM Bank India for executing the transaction.
          </DialogContentText>
          <Button onClickHandler={onYes} className="py-4 mb-5 font-bold text-white rounded px-7">
            I have read the Terms & Conditions thoroughly.
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
